import React from 'react'
import axios from 'axios'

const getAds = async ({ setAds }) => {
    const cancelToken = axios.CancelToken.source()

    await axios.post('https://www.thewordartisan.online/api/v1/ads', {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Content-Type": "application/json",
        }
    },
    {
        cancelToken: cancelToken.token
    })

    .then((response) => {
        const data = response.data.ads

        if (data) {
            let temp = data.filter(e => e.ads_id.includes('spanish'));
            setAds({ image: temp[0].ads_img, url: temp[0].ads_url })
        }
    })
    
    .catch((err) => {
        if (axios.isCancel(err)) {
            console.log("Axios post cancelled!")
        } else {
            console.log(err)
        }
    })
}

export default getAds